<template>
  <Head title="Sites" />
  <DashboardLayout>
    <DContainer fluid>
      <DRow class="mb-4">
        <DCol>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h1 class="h3 mb-1">Sites</h1>
              <p class="text-muted mb-0">
                Hosted AstroAdmin editors and their live sites
              </p>
            </div>
            <Link href="/sites/create" class="btn btn-primary">
              <i-bi-plus-circle-fill
                class="me-2"
                style="width: 18px; height: 18px"
              />
              Add Site
            </Link>
          </div>
        </DCol>
      </DRow>

      <DRow v-if="sites.length > 0" class="g-4">
        <DCol v-for="site in sites" :key="site.id" md="6" xl="4">
          <SiteCard :site="site" />
        </DCol>
      </DRow>
      <DRow v-else>
        <DCol>
          <DCard class="border-0 shadow-sm text-center text-muted py-5">
            No sites yet — add your first one.
          </DCard>
        </DCol>
      </DRow>
    </DContainer>
  </DashboardLayout>
</template>

<script setup lang="ts">
import { Link, Head } from "@inertiajs/vue3";
import {
  DContainer,
  DRow,
  DCol,
  DCard,
} from "@omnitend/dashboard-for-laravel";
import DashboardLayout from "../../Layouts/DashboardLayout.vue";
import SiteCard from "../../Components/SiteCard.vue";
import type { Site } from "../../types";

defineProps<{
  sites: Site[];
}>();
</script>
